import { useAppDispatch, useAppSelector } from 'app/hooks';
import { MOBILE_ORDER_DISPLAY_ONLY_EDITED } from 'features/Store/constants';
import { COLUMN_WIDTH } from 'features/Store/pages/StoreSettingDetailPage';
import {
  selectStoreSettingDetailDisplayType,
  selectStoreSettingDetailExpandAll,
  selectStoreSettingEditedMenuBookIds,
  storeSettingDetailActions,
} from 'features/Store/storeSettingDetailSlice';
import { countSubGenreHasEditedMObileOrderDisplayFlg, getIsExpandStatus } from 'features/Store/utils';
import React, { useEffect, useState } from 'react';
import { MINUS_TEXT, PLUS_TEXT } from 'utils';
import { Course, Genre, MenuBook, SubGenre } from '../../models';

export interface SubGenreRowCollapseProps {
  menuBook: MenuBook;
  course?: Course;
  genre: Genre;
  subgenre: SubGenre;
  children?: React.ReactNode;
}

function SubGenreRow({ menuBook, course, genre, subgenre, children }: SubGenreRowCollapseProps) {
  const dispatch = useAppDispatch();
  const editedMenuBookIds = useAppSelector(selectStoreSettingEditedMenuBookIds);
  const isExpand = useAppSelector(selectStoreSettingDetailExpandAll);
  const displayType = useAppSelector(selectStoreSettingDetailDisplayType);

  const [open, setOpen] = useState(getIsExpandStatus(menuBook, editedMenuBookIds, isExpand));

  let pathId = `${menuBook.id}-${genre.id}-${subgenre.id}`;
  if (course) {
    pathId = `${menuBook.id}-${course.id}-${genre.id}-${subgenre.id}`;
  }

  useEffect(() => {
    const btnExpandElem = document.querySelector(`#subgenre-${pathId}-row .dan-btn-expand`) as HTMLButtonElement;
    function handleBtnExpandElemClick(event: MouseEvent) {
      event.stopPropagation();
      setOpen(!open);
      dispatch(storeSettingDetailActions.setExpandAll(undefined));
      btnExpandElem.innerHTML = !open ? MINUS_TEXT : PLUS_TEXT;
      btnExpandElem?.setAttribute('aria-expanded', !open ? 'true' : 'false');
    }

    if (btnExpandElem) {
      btnExpandElem.addEventListener('click', handleBtnExpandElemClick);
    }

    return () => {
      if (btnExpandElem) {
        btnExpandElem.removeEventListener('click', handleBtnExpandElemClick);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, displayType]);

  useEffect(() => {
    if (isExpand !== undefined) {
      setOpen(getIsExpandStatus(menuBook, editedMenuBookIds, isExpand));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpand]);

  const countTotalEditedMobileOrderDisplay = countSubGenreHasEditedMObileOrderDisplayFlg(subgenre);
  if (displayType === MOBILE_ORDER_DISPLAY_ONLY_EDITED && countTotalEditedMobileOrderDisplay === 0) {
    return null;
  }

  return (
    <>
      <div id={`subgenre-${pathId}-row`} className="dan-tr main content-visibility-auto">
        <div
          className="dan-td"
          style={{
            width: `${COLUMN_WIDTH.slice(0, 3).reduce((sum, width) => sum + width, 0)}%`,
          }}
        ></div>
        <div className="dan-td" style={{ width: `${COLUMN_WIDTH[3]}%` }}>
          <button
            className="dan-btn-expand"
            tabIndex={-1}
            aria-controls={`subgenre-${pathId}-content`}
            aria-expanded={open}
          >
            {open ? MINUS_TEXT : PLUS_TEXT}
          </button>
          <span>{subgenre.name}</span>
        </div>
        <div
          className="dan-td"
          style={{
            width: `${COLUMN_WIDTH.slice(4, 17).reduce((sum, width) => sum + width, 0)}%`,
          }}
        ></div>
      </div>
      {/* <div style={{ display: open ? 'block' : 'none' }}> */}
      <div style={{ contentVisibility: open ? 'auto' : 'hidden' }}>
        <div id={`subgenre-${pathId}-content`}>{children}</div>
      </div>
    </>
  );
}

export default SubGenreRow;
